import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { Badge } from '@mui/material';
import { IconButton } from 'components/IconButton';
import Notifications from 'modules/Notifications';
import store from 'store';

import BellRingingIcon from '@common/assets/icons/BellRinging.svg';

function BellRingButton() {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'notification-popover' : undefined;

	return (
		<Badge badgeContent={store.notifications.unreadCount} color="primary">
			<IconButton
				onClick={handleClick}
				sx={(theme) => ({
					background: open ? '#FFFFFF80' : 'transparent',
					...(open && { color: theme.palette.primary.main }),
				})}
				size="large"
				variant="contained"
			>
				<BellRingingIcon />
			</IconButton>
			<Notifications
				open={open}
				id={id}
				anchorEl={anchorEl}
				onCloseButtonClick={handleClose}
				onClose={handleClose}
			/>
		</Badge>
	);
}

export default observer(BellRingButton);
